// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

export const HeaderWrapper = styled.div<{ isDark: boolean }>(
  ({ theme, isDark }) => css`
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid
      ${isDark ? theme.colors.gray['dark-24'] : theme.colors.gray.light};
    padding: 12px 23px;
  `,
);

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  height: 100%;
  overflow: auto;
  padding: 40px 20px;
`;

export const FooterWrapper = styled.div<{ isDark: boolean }>(
  ({ theme, isDark }) => css`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: end;
    color: ${isDark ? theme.colors.white : theme.colors.base.dark};
    border-top: 1px solid
      ${isDark ? theme.colors.gray['dark-24'] : theme.colors.gray.light};
    background-color: ${
      isDark ? theme.colors.base['light-dark-mode'] : theme.colors.gray.lighter
    };
  `,
);

export const BeautyButton = styled.a<{ isDark: boolean }>(
  ({ theme, isDark }) => css`
    display: flex;
    align-items: center;
    color: ${isDark ? theme.colors.secondary.main : theme.colors.primary.main};
    gap: 4px;
    cursor: pointer;

    :hover {
      color: ${
        isDark ? theme.colors.secondary.light : theme.colors.primary.lighter
      };
    }
  `,
);

export const Article = styled.a<{ isDark: boolean }>(
  ({ theme, isDark }) => css`
    display: flex;
    padding: 11px 13px;
    color: ${isDark ? theme.colors.white : theme.colors.base.main};
    border: 1px solid
      ${isDark ? theme.colors.gray.light : theme.colors.gray['dark-24']};
    border-radius: 5px;

    :hover {
      background-color: ${theme.colors.gray['dark-8']};
    }
  `,
);

export const Divider = styled.div<{ isDark: boolean }>(
  ({ theme, isDark }) => css`
    border-bottom: 1px solid
      ${isDark ? theme.colors.gray['dark-24'] : theme.colors.gray.light};
  `,
);

export const AssistanceWrapper = styled.a<{ isDark: boolean }>(
  ({ theme, isDark }) => css`
    display: flex;
    padding: 20px 36px;

    :hover {
      background-color: ${
        isDark ? theme.colors.gray['dark-8'] : theme.colors.gray.light
      };
    }
  `,
);

export const MailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 14px 36px 25px;
`;
